export const MAX_AXLES_COUNT = 9;
